export default ({ request }) => ({
  materialInfoListApi(data = {}) {
    return request({
      url: '/master/material/info/list',
      method: 'post',
      data,
    })
  },
  materialInfoDetailApi(data = {}) {
    return request({
      url: '/master/material/info/detail',
      method: 'post',
      data,
    })
  },
  materialInfoSaveApi(data = {}) {
    return request({
      url: '/master/material/info/save',
      method: 'post',
      data,
    })
  },
  materialInfoDelApi(data = {}) {
    return request({
      url: '/master/material/info/del',
      method: 'post',
      data,
    })
  },
  materialInfoCopyApi(data = {}) {
    return request({
      url: '/master/material/info/copy',
      method: 'post',
      data,
    })
  },
  setMaterialInfoDefaultImageApi(data = {}) {
    return request({
      url: '/master/material/info/image/defaultImage',
      method: 'post',
      data,
    })
  },
  materialInfoImageListApi(data = {}) {
    return request({
      url: '/master/material/info/image/list',
      method: 'post',
      data,
    })
  },
  materialInfoImageBatchUploadApi(data = {}) {
    return request({
      url: '/master/material/info/image/batch/upload',
      method: 'post',
      data,
    })
  },
  materialInfoImageDelApi(data = {}) {
    return request({
      url: '/master/material/info/image/del',
      method: 'post',
      data,
    })
  },
  materialInfoImageUpdateSortOrderApi(data = {}) {
    return request({
      url: '/master/material/info/image/update/sortOrder',
      method: 'post',
      data,
    })
  },
  materialInfoDocListApi(data = {}) {
    return request({
      url: '/master/material/info/doc/list',
      method: 'post',
      data,
    })
  },
  materialInfoDocBatchUploadApi(data = {}) {
    return request({
      url: '/master/material/info/doc/batch/upload',
      method: 'post',
      data,
    })
  },
  materialInfoDocDelApi(data = {}) {
    return request({
      url: '/master/material/info/doc/del',
      method: 'post',
      data,
    })
  },
  materialInfoDocUploadApi(data = {}) {
    return request({
      url: '/master/material/info/doc/upload',
      method: 'post',
      data,
    })
  },
  materialInfoDocDetailApi(data = {}) {
    return request({
      url: '/master/material/info/doc/detail',
      method: 'post',
      data,
    })
  },
  
  // materialInfoDocDownloadFileApi(url) {
  //   return request({
  //     url,
  //     method: 'get',
  //     responseType: 'blob',
  //   })
  // },
})
